import { render } from "./UserSnsButtons.vue?vue&type=template&id=225dbcf3&scoped=true&ts=true&lang=pug"
import script from "./UserSnsButtons.vue?vue&type=script&lang=ts"
export * from "./UserSnsButtons.vue?vue&type=script&lang=ts"

import "./UserSnsButtons.vue?vue&type=style&index=0&id=225dbcf3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225dbcf3"]])

export default __exports__